export enum LOCAL_STORAGE_KEYS {
  ACCESS_TOKEN = "accessToken",
  TOKEN = "token"
}

export const UNKNOWN = "UNKNOWN";
